/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  SettleRealizedPnlRecordsOptions,
  SettleRealizedPnlRecordsStatus200,
  SettleRealizedPnlRecordsStatus400,
  SettleRealizedPnlRecordsStatus401,
  SettleRealizedPnlRecordsStatus403,
  SettleRealizedPnlRecordsStatus500,
} from '../types/SettleRealizedPnlRecords'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { settleRealizedPnlRecords } from '../clients/settleRealizedPnlRecords'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const settleRealizedPnlRecordsMutationKey = () =>
  [{ url: '/v1/realized_pnl_settlements' }] as const

export function settleRealizedPnlRecordsMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = settleRealizedPnlRecordsMutationKey()
  return mutationOptions<
    SettleRealizedPnlRecordsStatus200,
    ResponseErrorConfig<
      | SettleRealizedPnlRecordsStatus400
      | SettleRealizedPnlRecordsStatus401
      | SettleRealizedPnlRecordsStatus403
      | SettleRealizedPnlRecordsStatus500
    >,
    SettleRealizedPnlRecordsOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return settleRealizedPnlRecords({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Mark multiple realized P&L settlements as settled
 * {@link /v1/realized_pnl_settlements}
 */
export function useSettleRealizedPnlRecords<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SettleRealizedPnlRecordsStatus200,
      ResponseErrorConfig<
        | SettleRealizedPnlRecordsStatus400
        | SettleRealizedPnlRecordsStatus401
        | SettleRealizedPnlRecordsStatus403
        | SettleRealizedPnlRecordsStatus500
      >,
      SettleRealizedPnlRecordsOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? settleRealizedPnlRecordsMutationKey()

  const baseOptions = settleRealizedPnlRecordsMutationOptions(config) as UseMutationOptions<
    SettleRealizedPnlRecordsStatus200,
    ResponseErrorConfig<
      | SettleRealizedPnlRecordsStatus400
      | SettleRealizedPnlRecordsStatus401
      | SettleRealizedPnlRecordsStatus403
      | SettleRealizedPnlRecordsStatus500
    >,
    SettleRealizedPnlRecordsOptions,
    TContext
  >

  return useMutation<
    SettleRealizedPnlRecordsStatus200,
    ResponseErrorConfig<
      | SettleRealizedPnlRecordsStatus400
      | SettleRealizedPnlRecordsStatus401
      | SettleRealizedPnlRecordsStatus403
      | SettleRealizedPnlRecordsStatus500
    >,
    SettleRealizedPnlRecordsOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    SettleRealizedPnlRecordsStatus200,
    ResponseErrorConfig<
      | SettleRealizedPnlRecordsStatus400
      | SettleRealizedPnlRecordsStatus401
      | SettleRealizedPnlRecordsStatus403
      | SettleRealizedPnlRecordsStatus500
    >,
    SettleRealizedPnlRecordsOptions,
    TContext
  >
}
